import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../pages/Home';
import About from '../pages/About';
import Contact from '../pages/Contact';
import Why from '../pages/Why';

function PageNavigation() {
	return (
		<Routes>
			<Route path="/" element={<Home />} />
			<Route path="/about-us" element={<About />} />
			<Route path="/contact" element={<Contact />} />
			<Route path="/why" element={<Why />} />
		</Routes>
	);
}

export default PageNavigation;
